export const foundFlag = {
  "found-flag": {
    shape:
      '<path fill="#000" fill-opacity=".51" d="M5.5 21.5v-19h1v2h13.775L18.45 9l1.825 4.5H6.5v8h-1Zm7-11c.417 0 .77-.146 1.062-.438C13.854 9.771 14 9.417 14 9c0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 12.5 7.5c-.417 0-.77.146-1.062.438A1.444 1.444 0 0 0 11 9c0 .417.146.77.438 1.062.291.292.645.438 1.062.438Zm-6 2h12.275L17.4 9l1.375-3.5H6.5v7Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
